import React from "react";
import { Scale } from "lucide-react";
import GrievanceDisputeContents from "./components/GrievanceDisputeContents";
import FullHeaderComponent from "../components/FullHeaderComponent";

const GrievanceAndDispute = () => {
  return (
    <div className="flex flex-col -mx-3 sm:-mx-4 md:-mx-6 -mt-3 sm:-mt-4 md:-mt-6">
      <FullHeaderComponent
        icon={Scale}
        title="Grievance and Dispute Resolution Policy"
        subtitle="Hyvid Philippines · Owner: People & Culture · Review: Annually"
        hyvidScope="Applies to: All Hyvid Philippines employees"
        reviewTime="Annually"
      />
      <div>
        <GrievanceDisputeContents/>
      </div>
    </div>
  );
};

export default GrievanceAndDispute;